<template>
  <div>
    <md-card>
      <md-card-header>
        <h4 class="card-title">Filtros</h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div
            class="md-layout-item md-layout md-medium-size-40 md-small-size-40 md-xsmall-size-100"
          >
            <div class="md-layout-item">
              <strong>Fecha de Asignacion</strong>
            </div>
            <div class="md-layout-item md-layout md-size-100">
              <div class="md-layout-item md-size-50">
                <md-datepicker
                  v-model="selectedDateInicial"
                  :md-open-on-focus="false"
                >
                  <label>Inicio:</label>
                </md-datepicker>
              </div>
              <div class="md-layout-item md-size-50">
                <md-datepicker
                  v-model="selectedDateFinal"
                  :md-open-on-focus="false"
                >
                  <label>Fin:</label>
                </md-datepicker>
              </div>
            </div>
          </div>

          <div
            class="md-layout-item md-layout md-medium-size-20 md-small-size-20 md-xsmall-size-100 md-gutter"
          >
            <div class="md-layout-item">
              <strong>Autopista</strong>
              <md-field>
                <label for="autopista">Autopista</label>
                <md-select
                  v-model="selectedAutopista"
                  name="autopista"
                  id="autopista"
                  multiple
                >
                  <md-option>Fight Club</md-option>
                  <md-option>Godfather</md-option>
                  <md-option>Godfather II</md-option>
                  <md-option>Godfather III</md-option>
                  <md-option>Godfellas</md-option>
                  <md-option>Pulp Fiction</md-option>
                  <md-option>Scarface</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div
            class="md-layout-item md-layout md-medium-size-20 md-small-size-20 md-xsmall-size-100 md-gutter"
          >
            <div class="md-layout-item">
              <strong>Analista de Costos</strong>
              <md-field>
                <label for="analista">Analista</label>
                <md-select
                  v-model="selectedAnalista"
                  name="analista"
                  id="analista"
                  multiple
                >
                  <md-option value="scarface">Fight Club</md-option>
                  <md-option value="scarface">Godfather</md-option>
                  <md-option value="scarface">Godfather II</md-option>
                  <md-option value="scarface">Godfather III</md-option>
                  <md-option value="scarface">Godfellas</md-option>
                  <md-option value="scarface">Pulp Fiction</md-option>
                  <md-option value="scarface">Scarface</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div
            class="md-layout-item md-layout md-medium-size-20 md-small-size-20 md-xsmall-size-100 md-gutter"
          >
            <div class="md-layout-item">
              <strong>Status</strong>
              <md-field>
                <label for="status">Status</label>
                <md-select
                  v-model="selectedStatus"
                  name="status"
                  id="status"
                  multiple
                >
                  <md-option>Fight Club</md-option>
                  <md-option>Godfather</md-option>
                  <md-option>Godfather II</md-option>
                  <md-option>Godfather III</md-option>
                  <md-option>Godfellas</md-option>
                  <md-option>Pulp Fiction</md-option>
                  <md-option>Scarface</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { Slider, Collapse } from '@/components'

export default {
  components: {
    Slider,
    Collapse,
  },
  data() {
    return {
      responsive: false,
      // selectedLabeled: null,
      // selectedClose: null,
      selectedDateInicial: new Date("2018/03/26"),
      selectedDateFinal: new Date("2018/03/26"),
      //movie: 'godfather',
      autopista:'',
      analista:'',
      status:'',
      selectedAutopista: [],
      selectedAnalista: [],
      selectedStatus: [],
    };
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Sinister/Filters/Filter.vue